import { StrategyBuilderFunction, EMPTY_STRATEGY } from './types';
import { addShortCall, addShortPut } from './addOption';
import {
  getDefaultExpiration,
  findClosestStrikePrice,
  getStrikesAtExpiration,
  expirationToDate,
  getPremium,
  getStrategyLegStrikeDirection,
} from './utils';

export const shortStraddle: StrategyBuilderFunction = ({
  chain,
  spot,
  expirationDate,
  expirationKey,
  strikeDirection,
  contractMultiplier = 1,
}) => {
  const strikesAtExpiration = expirationKey
    ? getStrikesAtExpiration(chain, expirationKey)
    : getDefaultExpiration(chain);

  if (
    !strikesAtExpiration ||
    !strikesAtExpiration.e ||
    !strikesAtExpiration.ey ||
    !strikesAtExpiration.em ||
    !strikesAtExpiration.ed
  ) {
    return EMPTY_STRATEGY;
  }

  const expirationDateForOptions =
    expirationDate ||
    expirationToDate(strikesAtExpiration.ey, strikesAtExpiration.em, strikesAtExpiration.ed);
  const expirationKeyForOptions = expirationKey || strikesAtExpiration.e;

  // Choosing the strike price closest to the current spot price
  const strikePrice = findClosestStrikePrice(strikesAtExpiration, spot);

  return {
    optionPositions: [
      // Sell a call option
      addShortCall({
        strike: strikePrice,
        premium: getPremium({
          ask: strikesAtExpiration?.c?.[strikePrice]?.c?.a || 0,
          bid: strikesAtExpiration?.c?.[strikePrice]?.c?.b || 0,
          strikeDirection: getStrategyLegStrikeDirection(strikeDirection, 'short'),
        }),
        expirationDate: expirationDateForOptions,
        expirationKey: expirationKeyForOptions,
        numberOfContracts: 1 * contractMultiplier,
      }),
      // Sell a put option
      addShortPut({
        strike: strikePrice,
        premium: getPremium({
          ask: strikesAtExpiration?.c?.[strikePrice]?.p?.a || 0,
          bid: strikesAtExpiration?.c?.[strikePrice]?.p?.b || 0,
          strikeDirection: getStrategyLegStrikeDirection(strikeDirection, 'short'),
        }),
        expirationDate: expirationDateForOptions,
        expirationKey: expirationKeyForOptions,
        numberOfContracts: 1 * contractMultiplier,
      }),
    ],
    stockPositions: [],
  };
};
